<script setup lang="ts">
import { useSurfaceTimelineFormatStore } from '@@/pinia/surface_timeline_format_store';
import { storeToRefs } from 'pinia';

defineProps<{
  darkMode: boolean
}>()

const { adjustedPrimaryBackgroundColorForDashedLine } = storeToRefs(useSurfaceTimelineFormatStore())
</script>

<template>
  <span
    :class="['w-3 h-0.75 rounded-[4px] dashed-line backdrop-blur-12', darkMode ? 'opacity-80' : 'opacity-70']"
    :style="{ backgroundColor: adjustedPrimaryBackgroundColorForDashedLine }"
  />
</template>
